module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAARUlEQVQ4y2P4jwQ+MAww7wADDNgPPI//D4jB/H8w8IBuggkNOI8fHFlwdw4sD+IohkHBgyTiwcH7A03Og4A3iPL04CnrAN3PyGP+Sv4mAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTEzVDE1OjI3OjA4KzA5OjAwEILqywAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxMy0xMC0wOFQwNjowODoyMiswOTowMD+oKM0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_01871_100x100.png
// module id = rBSZ
// module chunks = 0